import { Spinner as ReactBootStrapSpinner } from 'react-bootstrap';

export function Spinner() {
  return <ReactBootStrapSpinner style={{ margin: 'auto', display: 'block' }} />;
}
